enum EErrorPageType {
    NOT_SERVICED_COUNTRY = 'not-serviced-country',
}

export { EErrorPageType }
